<template>
    <div class="">
        <md-dialog :md-active.sync="modalAdCentroCostos" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content class="">
                <b-row class="text-center" v-if="listCentroCostos.length > 0">
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.centroCosto}}</h5>
                    </b-col>
                    <b-col cols="1"></b-col>
                    <b-col cols="6">
                        <select class="form-control" v-model="centroCosto">
                            <option value="">Seleccione...</option>
                            <option v-for="centroCostosSel in listCentroCostos" :key="centroCostosSel.id" :value="centroCostosSel.centro_costo">{{ centroCostosSel.descripcion }} ({{centroCostosSel.centro_costo}})</option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="text-center" v-if="listCentroCostos.length > 0">
			<b-col cols="4" class="text-left">
				<h5>{{labels.porcentaje}}</h5>
			</b-col>
			<b-col cols="1"></b-col>
            <b-col cols="6">
			<input type="number" v-model="porcentaje" class="form-control">
            </b-col>
                </b-row>
                <b-row class="justify-content-center" v-else>
                    <h6>{{ labels.noData }}</h6>
                </b-row>
                <md-dialog-actions class="mt-1">
                    <b-col cols="3">
                        <md-button class="md-primary" @click="aceptaCentroCostos">{{ labels.save }}</md-button>
                    </b-col>
                    <b-col cols="2">
                        <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                    </b-col>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import ContratoCentroCostos from '../../services/ContratoCentroCostos'
import CentroCostos from '../../services/CentroCostos'
export default {
    name : 'AdicionarCentroCostos',
    props:['modalAdCentroCostos','numContrato','vigencia','newVigencia'],
    components:{
    },
    data : () => ({
        centroCosto : '',
        vigencia : '',
        porcentaje : '',
        listCentroCostos : [],
        listContrato : [],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Adicionar centro de costo',
                    save : 'Guardar',
                    close : 'Cerrar',
                    detalle : 'Modificación Detalle',
                    activos : 'Modificación CentroCostos',
                    cuotas : 'Cuotas',
                    noData : 'No hay Centros de Costos disponibles.',
                    centroCosto : "Centro Costo",
                    porcentaje : "Porcentaje",
                }
            }else{
                return {
                    title : 'Add cost center',
                    save : 'Save',
                    close : 'Close',
                    detalle : 'Detail',
                    activos : 'Assets',
                    cuotas : 'Cuotas',
                    noData : 'No assets available.',
                    centroCosto : "Centro Costo",
                    porcentaje : "Porcentaje",
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        aceptaCentroCostos(){

            const info = {
                'numContrato' : this.numContrato,
                'vigencia' : this.vigencia,
                'newVigencia' : this.newVigencia == '' ? this.vigencia : this.newVigencia,
                'centroCosto' : this.centroCosto,
                'porcentaje' : this.porcentaje,
                'idUser' : this.$store.state.userId
            }
            // console.log(info);

            if (Object.values(info).includes('')) {
                return this.$toast.error('Campo(s) pendiente(s) por diligenciar.');
            }

            ContratoCentroCostos.adicionaCentroCosto(info)
            .then((response) => {
                this.$toast.success(response.data.message)
                this.$emit('reloadTblCntCst',this.vigencia)
                this.centroCosto = ''
                this.porcentaje = ''
            })
            .catch((error) => {                
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message);
                }
            })
        }
    },
    mounted(){
        CentroCostos.getAllCentroCostos()
        .then((res) => {
            this.listCentroCostos = res.data.listCentroCostos
            // console.log(this.listCentroCostos)
        })
        .catch((err) => console.log(err))
    }
}
</script>
<style lang="css">
  .md-table-cell-container {
    padding: 15px !important;
  }
  .md-table-head-label {
    padding-left: 30px !important;
  }
</style>
